import { apiSlice } from "app/api/apiSlice";

export const licenseApiSlice = apiSlice.injectEndpoints({

    endpoints: builder => ({

        // GET LicenseInfo
        getLicenseInfo: builder.query({
            query: () => '/license'
        }),
    })
})

export const {
    useGetLicenseInfoQuery
} = licenseApiSlice